<irembogov-custom-vertical-stepper
  [fields]="filterFields()"
  orientation="vertical"
  [linear]="true"
  [selectedIndex]="validSelectedIndex$ | async">
  <cdk-step *ngFor="let step of filterFields()"></cdk-step>
</irembogov-custom-vertical-stepper>
